import { render } from "./AdmissionTimiline.vue?vue&type=template&id=dae4e4e6&scoped=true"
import script from "./AdmissionTimiline.vue?vue&type=script&lang=js"
export * from "./AdmissionTimiline.vue?vue&type=script&lang=js"

import "./AdmissionTimiline.vue?vue&type=style&index=0&id=dae4e4e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae4e4e6"]])

export default __exports__